import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandMyTimePlan(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Zm7.906-10.447a1.13 1.13 0 0 1-1.13 1.13v1.129a1.13 1.13 0 0 1-2.258 0v-1.28a1.124 1.124 0 0 1-.565.15v1.13a1.13 1.13 0 0 1-2.258 0v-1.13c-.338 0-.64-.148-.848-.382a1.118 1.118 0 0 1-.048.052L10.54 14.21a1.13 1.13 0 0 1-1.856-.402l-.403.402a1.13 1.13 0 0 1-1.856-.402l-.402.402a1.13 1.13 0 1 1-1.598-1.597l2.26-2.259a1.13 1.13 0 0 1 1.856.403l.402-.403a1.13 1.13 0 0 1 1.857.403l.402-.403a1.13 1.13 0 0 1 1.646.052c.206-.235.51-.383.846-.383h2.26c.337 0 .64.148.846.383.207-.235.51-.383.847-.383h1.13c.623 0 1.129.506 1.129 1.13Z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Zm7.906-10.447a1.13 1.13 0 0 1-1.13 1.13v1.129a1.13 1.13 0 0 1-2.258 0v-1.28a1.124 1.124 0 0 1-.565.15v1.13a1.13 1.13 0 0 1-2.258 0v-1.13c-.338 0-.64-.148-.848-.382a1.118 1.118 0 0 1-.048.052L10.54 14.21a1.13 1.13 0 0 1-1.856-.402l-.403.402a1.13 1.13 0 0 1-1.856-.402l-.402.402a1.13 1.13 0 1 1-1.598-1.597l2.26-2.259a1.13 1.13 0 0 1 1.856.403l.402-.403a1.13 1.13 0 0 1 1.857.403l.402-.403a1.13 1.13 0 0 1 1.646.052c.206-.235.51-.383.846-.383h2.26c.337 0 .64.148.846.383.207-.235.51-.383.847-.383h1.13c.623 0 1.129.506 1.129 1.13Z"
        fill="url(#mtp-gradient)"
      />
      <defs>
        <linearGradient
          id="mtp-gradient"
          x1="12"
          y1="2.4"
          x2="12"
          y2="21.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity=".35" />
          <stop offset="1" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
